import { fetchOpenConversations } from "@origin-digital/chat-client-sdk/api";

let shouldShowChatButtonPromise: Promise<boolean> | undefined;

/** Resolves whether an enabled host has an open conversation to show. */
export async function shouldShowChatButton(enabled: boolean): Promise<boolean> {
  if (!enabled) {
    return false;
  }

  if (shouldShowChatButtonPromise) {
    return shouldShowChatButtonPromise;
  }

  const lookupPromise = fetchOpenConversations()
    .then((response) => response.hasOpenConversations)
    .catch(() => {
      // Keep visibility failures non-blocking, but allow a later header mount
      // or caller to retry after transient token, network, or API failures.
      if (shouldShowChatButtonPromise === lookupPromise) {
        shouldShowChatButtonPromise = undefined;
      }
      return false;
    });
  shouldShowChatButtonPromise = lookupPromise;

  return lookupPromise;
}
